export default "__VITE_ASSET__3550fcab__"